import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { subtitleOf } from '../tableCore/mobileCard/mobileCard';
export function nextSort(current, columnId, direction) {
    if (direction != null) return {
        name: columnId,
        direction
    };
    if (current == null || current.name !== columnId) return {
        name: columnId,
        direction: 'desc'
    };
    return {
        name: columnId,
        direction: current.direction === 'desc' ? 'asc' : 'desc'
    };
}
export function toggledSelection(selected, rowId) {
    const next = new Set(selected);
    if (next.has(rowId)) {
        next.delete(rowId);
    } else {
        next.add(rowId);
    }
    return next;
}
// WHY: a phone's action sheet names the record it acts on; the main column is that name unless the table titles the sheet itself.
export function withMainSheetHeader(actions, mainColumn) {
    var _actions_menuSubtitle;
    if ((mainColumn === null || mainColumn === void 0 ? void 0 : mainColumn.type) !== 'text' || actions.menuTitle != null) return actions;
    return _object_spread_props(_object_spread({}, actions), {
        menuTitle: (row)=>{
            var _row_mainColumn_name;
            return String((_row_mainColumn_name = row[mainColumn.name]) !== null && _row_mainColumn_name !== void 0 ? _row_mainColumn_name : '');
        },
        menuSubtitle: (_actions_menuSubtitle = actions.menuSubtitle) !== null && _actions_menuSubtitle !== void 0 ? _actions_menuSubtitle : (row)=>subtitleOf(mainColumn, row)[0]
    });
}
export function virtualRowWindow(param) {
    let { count, scrollTop, viewportHeight, rowPitch, overscan, unmeasuredRows } = param;
    const visibleRows = viewportHeight > 0 ? Math.ceil(viewportHeight / rowPitch) : unmeasuredRows;
    const firstVisible = Math.floor(Math.max(0, scrollTop) / rowPitch);
    const start = Math.min(count, Math.max(0, firstVisible - overscan));
    const end = Math.min(count, firstVisible + visibleRows + overscan);
    return {
        start,
        end
    };
}
